/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ServerInformation } from '../models/server-information';
import { serverInformationGetServerInformation } from '../fn/server-information/server-information-get-server-information';
import { ServerInformationGetServerInformation$Params } from '../fn/server-information/server-information-get-server-information';

@Injectable({ providedIn: 'root' })
export class ServerInformationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `serverInformationGetServerInformation()` */
  static readonly ServerInformationGetServerInformationPath = '/server-information';

  /**
   * Get server information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serverInformationGetServerInformation()` instead.
   *
   * This method doesn't expect any request body.
   */
  serverInformationGetServerInformation$Response(params?: ServerInformationGetServerInformation$Params, context?: HttpContext): Observable<StrictHttpResponse<ServerInformation>> {
    const obs = serverInformationGetServerInformation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get server information.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serverInformationGetServerInformation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serverInformationGetServerInformation(params?: ServerInformationGetServerInformation$Params, context?: HttpContext): Observable<ServerInformation> {
    const resp = this.serverInformationGetServerInformation$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ServerInformation>): ServerInformation => r.body)
    );
  }

}
